/**
 * Check if a file is a PDF file by its extension.
 *
 * @param filename The name of the file to check.
 * @returns The file is a PDF file.
 */
export function isPdfFile(filename: string | null | undefined): boolean {
    if (!filename) {
        return false;
    }
    return filename.toLowerCase().endsWith('.pdf');
}
